const Mock = require('mockjs');

const policiesList = [
	{
		id: 1001,
		typeName: '法律',
		title: '宪法',
		content: '<img width="80%" src="http://copyright.gzcc315.com/images/120217234743.png" alt="">',
	},
	{
		id: 1002,
		typeName: '法律',
		title: '民法典',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217231746.png" alt="">',
	},
	{
		id: 1003,
		typeName: '法律',
		title: '刑法',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217225068.png" alt="">',
	},
	{
		id: 1004,
		typeName: '法律',
		title: '著作权法',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217221618.png" alt="">'
	},
	{
		id: 1005,
		typeName: '法律',
		title: '电影产业促进法',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217211796.png" alt="">',
	},
	{
		id: 1006,
		typeName: '行政法规',
		title: '著作权法实施条例',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217203818.png" alt="">',
	},
	{
		id: 1007,
		typeName: '行政法规',
		title: '计算机软件保护条例',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217195698.png" alt="">',
	},
	{
		id: 1008,
		typeName: '行政法规',
		title: '著作权集体管理条例',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217170881.png" alt="">',
	},
	{
		id: 1009,
		typeName: '行政法规',
		title: '信息网络传播权保护条例',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217162739.png" alt="">',
	},
	{
		id: 1010,
		typeName: '行政法规',
		title: '广播电台电视台播放录音制品支付报酬暂行办法',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217150248.png" alt="">',
	},
	{
		id: 1011,
		typeName: '部门规章',
		title: '录音法定许可付酬标准暂行规定',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217132760.png" alt="">',
	},
	{
		id: 1012,
		typeName: '部门规章',
		title: '作品自愿登记试行办法',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217123879.png" alt="">',
	},
	{
		id: 1013,
		typeName: '部门规章',
		title: '计算机软件著作权登记办法',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217103473.png" alt="">',
	},
	{
		id: 1014,
		typeName: '部门规章',
		title: '互联网著作权行政保护办法',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216425550.png" alt="">',
	},
	{
		id: 1015,
		typeName: '部门规章',
		title: '著作权行政处罚实施办法',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216440631.png" alt="">',
	},
	{
		id: 1016,
		typeName: '部门规章',
		title: '著作权质权登记办法',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216450279.png" alt="">',
	},
	{
		id: 1017,
		typeName: '部门规章',
		title: '教科书法定许可使用作品支付报酬办法',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216453039.png" alt="">',
	},
	{
		id: 1018,
		typeName: '部门规章',
		title: '使用文字作品支付报酬办法',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120217084295.png" alt="">',
	},
	{
		id: 1019,
		typeName: '司法解释',
		title: '最高人民法院关于审理著作权民事纠纷案件适用法律若干问题的解释',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216354823.png" alt="">',
	},
	{
		id: 1020,
		typeName: '司法解释',
		title: '最高人民法院关于审理涉及计算机网络著作权纠纷案件适用法律若干问题的解释',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216350001.png" alt="">',
	},
	{
		id: 1021,
		typeName: '司法解释',
		title: '最高人民法院关于审理侵害信息网络传播权民事纠纷案件适用法律若干问题的规定',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216334507.png" alt=""> ',
	},
	{
		id: 1022,
		typeName: '国际条约',
		title: '保护文学和艺术作品伯尔尼公约',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216471339.png" alt="">'
	},
	{
		id: 1023,
		typeName: '国际条约',
		title: '世界版权公约(1971年修订)',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216485100.png" alt="">'
	},
	{
		id: 1024,
		typeName: '国际条约',
		title: '视听表演北京条约',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216492587.png" alt="">'
	},
	{
		id: 1025,
		typeName: '国际条约',
		title: '保护录音制品制作者防止未经许可复制其录音制品公约',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216500153.png" alt="">'
	},
	{
		id: 1026,
		typeName: '国际条约',
		title: '与贸易有关的知识产权协议',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216503215.png" alt="">'
	},
	{
		id: 1027,
		typeName: '国际条约',
		title: '保护表演者,音像制品制作者和广播组织罗马公约',
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/120216510478.png" alt="">'
	},
	
];


Mock.mock('http://copyright.gzcc315.com/policiesList', 'get', options => {
    var arr = []
	for(var i = 0; i < 7; i++) {
        arr.push(policiesList[i])
    }
    return arr
})

Mock.mock('http://copyright.gzcc315.com/policiesClassify', 'get', options => {
    let { pageNum, type } = JSON.parse(options.body);
	let start = (pageNum * 12) - 12;
    let end = pageNum * 12;
    end = end > policiesList.length ? policiesList.length : end;
	let pageData = [];
	let list = [];
	for(let i = 0; i < policiesList.length; i++) {
		if(policiesList[i].typeName == type) {
			list.push(policiesList[i])
		}
	}
    for(let i = start; i < end; i++) {
        pageData.push(list[i])
	}
    return {
		pageData: list,
		total: list.length
    }
})


Mock.mock('http://copyright.gzcc315.com/policies', 'get', options => {
    let id = JSON.parse(options.body).id;
	for(var i = 0; i < policiesList.length; i++) {
		if(policiesList[i].id == id) {
			return policiesList[i]
		}
	}
})